export default "__VITE_ASSET__BFf4E5mQ__"